// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../../configs/apiConfig'


export const manageVehicleDetailCreate = createAsyncThunk('manageVehicleDetail/vehicle/create', async (params) => {
  const response = await apiHandle('POST', 'vehicle/create', params)
  return response
})

export const manageVehicleDetailUpdate = createAsyncThunk('manageVehicleDetail/vehicle/update', async (params) => {
  const response = await apiHandle('PUT', 'vehicle/update', params)
  return response
})

export const manageVehicleDetailRefund = createAsyncThunk('manageVehicleDetail/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const manageVehicleDetailDelete = createAsyncThunk('manageVehicleDetail/vehicle/delete', async (params) => {
  const response = await apiHandle('DELETE', 'vehicle/delete', params)
  return response
})


export const manageVehicleDetailPDFCreate = createAsyncThunk('manageVehicleDetail/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const manageVehicleDetailReaderCard = createAsyncThunk('manageVehicleDetail/manageVehicleDetailReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const manageVehicleDetailGetList = createAsyncThunk('manageVehicleDetail/vehicle/list', async (params) => {
  const response = await apiHandle('GET', 'vehicle/list', params)
  return response
})


export const getDataTable = createAsyncThunk('manageVehicleDetail/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'vehicle/expenses/gettable', params)
  return response
})


export const manageVehicleDetailDataDetail = createAsyncThunk('manageVehicleDetail/manageVehicleDetailDataDetail', async (params) => {
  const response = await apiHandle('GET', 'vehicle/get', params)
  return response
})

export const manageVehicleDetailGetCourse = createAsyncThunk('manageVehicleDetail/manageVehicleDetailGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getformanageVehicleDetail', params)
  return response
})

export const getAllData = createAsyncThunk('manageVehicleDetail/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('manageVehicleDetail/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('manageVehicleDetail/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('manageVehicleDetail/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('manageVehicleDetail/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})


const defaultVehicleDetail = {
  branch: null,
  branch_id: null,
  brand: null,
  color: null,
  createdAt: null,
  insurance_company: null,
  insurance_type: null,
  is_delete: null,
  model: null,
  no: null,
  note: null,
  noti_check: null,
  noti_compulsory: null,
  noti_insurance: null,
  noti_tax: null,
  province: null,
  purchase_date: null,
  status: null,
  type: null,
  updatedAt: null,
  vehicle_id: null,
  createStatus: false
}


export const manageVehicleDetailSlice = createSlice({
  name: 'manageVehicleDetail',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      list_expenses: { label: 'ทั้งหมด', value: '' },
      text: ''
    },
    manageVehicleDetailData: {
      data: [],
      filter: {
        branch: [],
        list_expenses: []
      },
      meta: {},
      isLoading: false
    },
    manageVehicleDetailDetail: {
      isEdit: false,
      dropdown: {
        branch: [],
        list_expenses: []
      },
      vehicleData: defaultVehicleDetail
    },
    alert: {
      active: false,
      message: ''
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'manageVehicleDetail/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    manageVehicleDetailNew: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailNew') {
        state.manageVehicleDetailDetail.isEdit = false
        state.manageVehicleDetailDetail.vehicleData = defaultVehicleDetail
      }
    },
    manageVehicleDetailAddHandle: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailAddHandle') {
        if (action.payload.target === 'course') {
          state.manageVehicleDetailDetail.vehicleData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.manageVehicleDetailDetail.vehicleData.other_fee.push(defaultOtherCost)
        }

      }
    },
    manageVehicleDetailDeleteHandle: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailDeleteHandle') {
        if (action.payload.target === 'course') {
          state.manageVehicleDetailDetail.vehicleData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.manageVehicleDetailDetail.vehicleData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    manageVehicleDetailDropdownHandle: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.manageVehicleDetailDetail.isEdit === false) {
          state.manageVehicleDetailDetail.vehicleData.course[action.payload.index].course_id = action.payload.value.course_id
          state.manageVehicleDetailDetail.vehicleData.course[action.payload.index].course_name = action.payload.value.name
          state.manageVehicleDetailDetail.vehicleData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.manageVehicleDetailDetail.vehicleData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.manageVehicleDetailDetail.isEdit === false) {
          state.manageVehicleDetailDetail.vehicleData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.manageVehicleDetailDetail.vehicleData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.manageVehicleDetailDetail.vehicleData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.manageVehicleDetailDetail.vehicleData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    manageVehicleDetailOnChangeHandle: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.manageVehicleDetailDetail.vehicleData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.manageVehicleDetailDetail.vehicleData[action.payload.target] = action.payload.value
        }

      }
    },
    manageVehicleDetailLoading: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailLoading') {
        state.manageVehicleDetailData.isLoading = true
      }
    },
    manageVehicleDetailAlert: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    manageVehicleDetailRefundDelete: (state, action) => {
      if (action.type === 'manageVehicleDetail/manageVehicleDetailRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(manageVehicleDetailCreate.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/vehicle/create/fulfilled') {
          if (action.payload.status === 'error') {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
            //handleError
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
          }
        }
      })
      .addCase(manageVehicleDetailUpdate.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/vehicle/update/fulfilled') {
          if (action.payload.status === 'error') {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
            //handleError
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
          }
        }
      })
      .addCase(manageVehicleDetailRefund.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(manageVehicleDetailDelete.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/vehicle/delete/fulfilled') {
          if (action.payload.status === 'error') {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
            //handleError
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
          }
        }
      })
      .addCase(manageVehicleDetailGetList.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'manageVehicleDetail/vehicle/list/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            if (action.payload.data.branch) {
              let branch = []
              for (const i of action.payload.data.branch) {
                branch.push({ value: i.value, label: i.name })
              }
              state.manageVehicleDetailDetail.dropdown.branch = branch
            } if (action.payload.data.status) {
              let status = []
              for (const i of action.payload.data.status) {
                status.push({ value: i, label: i })
              }
              state.manageVehicleDetailDetail.dropdown.status = status
            } if (action.payload.data.type) {
              let type = []
              for (const i of action.payload.data.type) {
                type.push({ value: i, label: i })
              }
              state.manageVehicleDetailDetail.dropdown.type = type
            }
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            if (action.payload.filter && Array.isArray(action.payload.filter.branch)) {
              let arr = [{ name: 'ทั้งหมด', value: 'ทั้งหมด' }]
              for (let i of action.payload.filter.branch) {
                arr.push({ name: i, value: i })
              }
              action.payload.filter.status = arr
            }
            if (action.payload.filter && Array.isArray(action.payload.filter.list_expenses)) {
              let arr = [{ name: 'ทั้งหมด', value: 'ทั้งหมด' }]
              for (let i of action.payload.filter.list_expenses) {
                arr.push({ name: i, value: i })
              }
              action.payload.filter.type = arr
            }
            state.manageVehicleDetailData = action.payload
            state.manageVehicleDetailData.isLoading = false
          }
        }
      })
      .addCase(manageVehicleDetailDataDetail.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/manageVehicleDetailDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.manageVehicleDetailDetail.isEdit = true
            for (const i in action.payload.data) {
              let data = action.payload.data[i]
              if (data === null) data = null
              state.manageVehicleDetailDetail.vehicleData[i] = data
            }
          }
        }
      })
      .addCase(manageVehicleDetailGetCourse.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/manageVehicleDetailGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageVehicleDetailDetail.dropdown.course = action.payload.course
            state.manageVehicleDetailDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(manageVehicleDetailReaderCard.fulfilled, (state, action) => {
        if (action.type === 'manageVehicleDetail/manageVehicleDetailReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.manageVehicleDetailDetail.vehicleData.prefix = action.payload.title_th
            state.manageVehicleDetailDetail.vehicleData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.manageVehicleDetailDetail.vehicleData.idcard = action.payload.nat_id
            state.manageVehicleDetailDetail.vehicleData.birthday = action.payload.birthdate
            state.manageVehicleDetailDetail.vehicleData.address = action.payload.address_no
            state.manageVehicleDetailDetail.vehicleData.street = action.payload.address_road
            state.manageVehicleDetailDetail.vehicleData.province = action.payload.address_provinice
            state.manageVehicleDetailDetail.vehicleData.district = action.payload.address_amphor
            state.manageVehicleDetailDetail.vehicleData.subdistrict = action.payload.address_tumbol
            state.manageVehicleDetailDetail.vehicleData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(manageVehicleDetailPDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'manageVehicleDetail/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, manageVehicleDetailNew, manageVehicleDetailAddHandle, manageVehicleDetailDropdownHandle, manageVehicleDetailDeleteHandle, manageVehicleDetailOnChangeHandle, manageVehicleDetailLoading, manageVehicleDetailAlert, manageVehicleDetailRefundDelete } = manageVehicleDetailSlice.actions

export default manageVehicleDetailSlice.reducer
